import styled from "styled-components";
import { Space } from "antd";

export const StyledInput = styled.input`
  width: 40px !important;
  height: 40px !important;
  border-radius: 12px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#E1CCE0")} !important;
  font-size: 17px !important;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 30px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 25px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled.div`
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #342309;
  text-align: left;
  cursor: pointer;
`;

export const TimeText = styled.div`
  margin-right: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #342309;
`;
